import { reactive } from 'vue'
import service from '@/utils/request'

// 所属公司下拉框（与转移申请审核的企业名称下拉一致）
export const useEnterpriseRemote = () => {
  const remoteData = reactive({
    isLoading: false,
    options: [],
    remoteMethod: (query: string) => {
      remoteData.isLoading = true
      if (query !== '') {
        service
          .request({
            method: 'post',
            url: 'admin/enterprise/dropdownOfEnterprise',
            data: { value: query }
          })
          .then((res: any) => {
            remoteData.isLoading = false
            remoteData.options = res.data.map((item: any) => {
              return {
                label: item.value,
                value: item.key
              }
            })
          })
      } else {
        remoteData.isLoading = false
        remoteData.options = []
      }
    }
  })
  return remoteData
}
